import PageHeader from "../components/PageHeader";
import PricingSection from "../components/PricingSection";
import ContactCTA from "../components/ContactCTA";

export default function Tarifs() {
  return (
    <div data-testid="page-tarifs">
      <PageHeader
        overline="Tarifs"
        title="Nos tarifs."
        lead="Prix pour le vol complet, tous passagers compris. Vols VIP, restaurant, mariage et entreprise établis sur devis personnalisé."
      />
      <PricingSection hideHeader />
      <ContactCTA />
    </div>
  );
}
